import { SPONSOR_URL, usePageMeta } from "../components/Layout.tsx";

export function Support() {
  usePageMeta("Support this", "Coding is free. Sponsorship pays for the time that keeps it maintained.");

  return (
    <article className="prose-page">
      <h1>Support this</h1>
      <p className="lede">
        Coding is free, has nothing to upsell and no paid tier planned. Sponsorship is what pays for the
        time.
      </p>

      <p>
        It is monthly and cancellable on purpose. This is an early project maintained by one person in
        the open, and you should be able to stop as easily as you started. If it stops earning it, stop
        paying for it.
      </p>

      <div className="cta">
        <a className="btn primary" href={SPONSOR_URL}>
          Sponsor on GitHub
        </a>
      </div>

      <h2>What sponsorship does not buy</h2>
      <p>
        No priority support, no private problems, no badge on the scoreboard, no vote on what gets built.
        Tying any of those to money would make the free version worse on purpose, and the free version is
        the whole product.
      </p>

      <h2>Cheaper ways to help</h2>
      <p>
        Send a problem worth adding, ideally one you were actually asked in an interview and got wrong.
        Those are worth more than money here: the bank is short, and every problem in it has to earn its
        place.
      </p>
    </article>
  );
}
